import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api, type HighscoreSubmission } from '@/api/client';

export function useHighscores(gameId?: string, limit = 10) {
  return useQuery({
    queryKey: ['highscores', gameId, limit],
    queryFn: () => 
      gameId 
        ? api.highscores.getByGame(gameId, limit)
        : api.highscores.getAll({ limit }),
  });
}

export function useAllHighscores(params?: { 
  game?: string; 
  limit?: number; 
  offset?: number 
}) {
  return useQuery({
    queryKey: ['highscores', 'all', params],
    queryFn: () => api.highscores.getAll(params),
  });
}

export function useSubmitHighscore() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (entry: HighscoreSubmission) => api.highscores.submit(entry),
    onSuccess: () => {
      // Invalidate all highscore queries
      queryClient.invalidateQueries({ queryKey: ['highscores'] });
    },
  });
}

export function useExportHighscores() {
  return useMutation({
    mutationFn: (gameId?: string) => api.highscores.exportCsv(gameId),
  });
}

export function useDeleteHighscores() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (gameId?: string) => api.highscores.deleteAll(gameId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['highscores'] });
    },
  });
}
